/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_NewInputs */

const cs_settings_teams_new = /** @type {(inputs: Settings_Teams_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový tým`)
};

const en_settings_teams_new = /** @type {(inputs: Settings_Teams_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New team`)
};

/**
* | output |
* | --- |
* | "New team" |
*
* @param {Settings_Teams_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_new = /** @type {((inputs?: Settings_Teams_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_new(inputs)
	return cs_settings_teams_new(inputs)
});